import services from "../services";

export const pendingBcrActions = {
  getPendingBcrApprovals,
  approveOrRejectPendingBcr,
};

function getPendingBcrApprovals(searchValues, setLoading) {
  return services.pendingBcrService.getPendingBcrApprovals(searchValues, setLoading);
}

function approveOrRejectPendingBcr(pendingBcrRequest, props) {
  return services.pendingBcrService.approveOrRejectPendingBcr(pendingBcrRequest, props);
}
